import { IconButton as MuiIconButton, styled } from '@mui/material'

export const IconButton = styled(MuiIconButton)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: '100%',
  height: 32,
  padding: 0,
  width: 32,
}))
